// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__20mK0","col":"Table_col__aR2L8","fulfillmentStatus":"Table_fulfillmentStatus__3VDmP","emailCol":"Table_emailCol__3HIXQ"};